// extracted by mini-css-extract-plugin
module.exports = {"container":"dece2e673c--container--mVgH2","edit_button":"dece2e673c--edit_button--pO9xz"};